module.exports = __webpack_public_path__ + "static/img/xzdyyy.f727ea2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/xzdyyy.png
// module id = rvZg
// module chunks = 0